import { useGetAdvertsQuery } from "@services/adverts/queries";
import { useCurrentLanguageCode } from "@utils/common";
import { AdditionalServiceAdvert } from "./components/AdditionalServiceAdvert/AdditionalServiceAdvert";

export const AdditionalServiceAdverts: React.FC = () => {
  const currentLanguageCode = useCurrentLanguageCode();
  const { data: advertsData } = useGetAdvertsQuery(currentLanguageCode);

  return (
    <>
      {advertsData
        ?.filter((advert) => advert.isAdditionalServicePageAdvertEnabled)
        .map((advert, index) => (
          <AdditionalServiceAdvert advert={advert} key={index} />
        ))}
    </>
  );
};
